import React from 'react';
import styled from 'styled-components';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  box-shadow: rgba(0, 0, 0, 0.075) 0px 0px 3px 0px;
`;
